import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { SparkFeedbackItem } from '../../types/sparkTypes';
import { normalizeMarkdownBullets } from '../../utils/markdown';
import styles from '../../styles/EvaluationFeedbackCard.module.css';

interface EvaluationFeedbackCardProps {
  feedback: SparkFeedbackItem;
  feedbackId?: string;
  logoUrl?: string;
  sourceName?: string;
  children?: React.ReactNode;
}

export const EvaluationFeedbackCard: React.FC<EvaluationFeedbackCardProps> = ({
  feedback,
  feedbackId,
  logoUrl,
  sourceName,
  children,
}) => {
  const title = sourceName ? `Evaluation by ${sourceName}` : 'Evaluation';

  return (
    <div className={styles.card} data-evaluation-feedback-id={feedbackId}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          {logoUrl && <img src={logoUrl} alt="" aria-hidden="true" className={styles.logo} />}
          <span className={styles.title}>{title}</span>
        </div>
      </div>
      <div className={styles.content}>
        {children || (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {normalizeMarkdownBullets(feedback._content)}
          </ReactMarkdown>
        )}
      </div>
    </div>
  );
};
